const TAXONOMY_RULES: Record<string, RegExp[]> = {
  STOP_SIGN: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/regulatory_sign\/right_of_way_sign\/right_of_way_sign_stop\/US\/R1-1$/i,
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/regulatory_sign\/right_of_way_sign\/right_of_way_sign_stop\/DE\/206$/i,
  ],
  ALL_WAY_STOP: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/regulatory_sign\/right_of_way_sign\/right_of_way_sign_stop_all_way\/US\/R1-3$/i,
  ],
  YIELD_SIGN: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/regulatory_sign\/right_of_way_sign\/right_of_way_sign_yield\/US\/R1-2$/i,
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/regulatory_sign\/right_of_way_sign\/right_of_way_sign_yield\/DE\/205$/i,
  ],
  NO_ENTRY: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/regulatory_sign\/road_use_sign\/road_use_sign_no_entry\/US\/R5-1$/i,
  ],
  PEDESTRIAN_CROSSING: [
    /scenery_elements\/drivable_area\/surface\/surface_feature\/road_marking\/road_marking_type\/location_specific_road_marking_type\/zebra_crossing_road_marking$/i,
  ],
  RAILROAD_CROSSING: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/warning_sign\/warning_sign_regarding_railroad_crossing_announcing\/US\/W10-13P$/i,
  ],
  NO_TURN_ON_RED: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/other_sign_signal_barrier\/US\/R10-11$/i,
  ],
  ONE_WAY: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/traveling_direction_sign\/traveling_direction_sign_one_way\/US\/R6-1L$/i,
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/traveling_direction_sign\/traveling_direction_sign_one_way\/US\/R6-1R$/i,
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/traveling_direction_sign\/traveling_direction_sign_one_way\/DE\/220-20$/i,
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/traveling_direction_sign\/traveling_direction_sign_one_way\/DE\/220-10$/i,
  ],
  ROUNDABOUT: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/traveling_direction_sign\/traveling_direction_sign_roundabout\/US\/W2-6$/i,
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/traveling_direction_sign\/traveling_direction_sign_roundabout\/US\/W2-8$/i,
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/traveling_direction_sign\/traveling_direction_sign_roundabout\/DE\/215$/i,
  ],
  TRAFFIC_LIGHT: [
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/doghouse$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/horizontal_2$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/horizontal_3$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/horizontal_4$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/horizontal_5$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/horizontal_6$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/horizontal_structure$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/triangular_structure$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/vertical_2$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/vertical_3$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/vertical_3x2$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/vertical_4$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/vertical_5$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/vertical_6$/i,
    /scenery_elements\/basic_road_structure\/street_furniture\/traffic_lights\/vertical_structure$/i,
  ],
  BUS_STOP: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/directional_sign\/directional_sign_bus_stop\/US\/R7-107$/i,
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/directional_sign\/directional_sign_bus_stop\/DE\/224$/i,
  ],
  PROTECTED_LEFT: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/regulatory_sign\/turn_sign\/turn_sign_protected_left\//i,
  ],
  PROTECTED_RIGHT: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/regulatory_sign\/turn_sign\/turn_sign_protected_right\//i,
  ],
  MERGE: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/warning_sign\/warning_sign_merge\//i,
  ],
  SCHOOL_ZONE: [/scenery_elements\/zone\/static_zone\/school_zone$/i],
  RIGHT_ON_RED: [
    /scenery_elements\/drivable_area\/sign_signal_barrier\/sign_signal_barrier_type\/regulatory_sign\/right_of_way_sign\/right_of_way_sign_turn_right_on_red\/rem\/e_green_tfl_arrow$/i,
  ],
}

export function filterTaxonomiesByType(
  taxonomies: string[],
  type: string,
): string[] {
  const rules = TAXONOMY_RULES[type]
  if (!rules) return []
  return taxonomies.filter(t => rules.some(rx => rx.test(t)))
}

export function getTypeFromTaxonomy(taxonomy: string): string | null {
  for (const [type, rules] of Object.entries(TAXONOMY_RULES)) {
    if (rules.some(rx => rx.test(taxonomy))) return type
  }
  return null
}
